/* CaptureNameComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CaptureNameRenderer");

class CaptureNameComponent extends EventEmitter {
    constructor() {
        super();
        this._titleText = "Capture - Snapshot Name";
        this._renderer = new Renderer(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "CaptureNameComponent.shutdown() error");
            }
        );
    }

    startCapture(name) {
        this._context.resolve({ name: name, setSchedule: false });
    }

    setSchedule(name) {
        this._context.resolve({ name: name, setSchedule: true });
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = CaptureNameComponent;
